import request from '@/utils/request'
import { v2Host } from '@/config/host'
// import { cookRequestParams } from '@/modules/common/request'

/**
 * getAppTagList
 * http://playable.dev.com:8067/?doc=system/app_tag.go
 * @param {{type: number}} params
 */
export function getAppTagList(params) {
  return request({
    url: `${v2Host}/system/app-tag/list`,
    method: 'get',
    params: params
  })
}

/**
 * 创建标签
 * http://playable.dev.com:8067/?doc=system/app_tag.go
 * @param {{type: number, pid: number, name: string, is_required: number}} data
 */
export function createAppTag(data) {
  return request({
    url: `${v2Host}/system/app-tag/create`,
    method: 'post',
    data: data
  })
}

/**
 * 更新标签
 * http://playable.dev.com:8067/?doc=system/app_tag.go
 * @param {{id: number}}
 * @param {{name: string, is_required: number}} data
 */
export function updateAppTag(params, data) {
  return request({
    url: `${v2Host}/system/app-tag/update`,
    method: 'post',
    params: params,
    data: data
  })
}

/**
 * 删除标签
 * http://playable.dev.com:8067/?doc=system/app_tag.go
 * @param {{id: number}} params
 */
export function deleteAppTag(params) {
  return request({
    url: `${v2Host}/system/app-tag/delete`,
    method: 'post',
    params: params
  })
}
